import {RedirectResponse} from "./RedirectResponse.js";

/**
 * @deprecated see RedirectResponse
 */
export class Redirect extends RedirectResponse {}
